import React, { useState } from "react";
import { HelpCircle, X, Phone, MessageCircle, Mail } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";

const waLink = (num) => {
  const digits = (num || "").replace(/\D/g, "");
  const full = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${full}`;
};

export const HelpButton = () => {
  const [open, setOpen] = useState(false);
  const { settings } = useSettings();
  const phone = settings?.whatsapp || settings?.contact_phone || "";
  const email = settings?.contact_email || "";

  return (
    <>
      <button
        data-testid="help-toggle"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-5 left-5 z-[60] inline-flex items-center gap-2 rounded-full bg-white border border-[#E5DFD3] text-choco shadow-lg px-4 h-12 hover:border-goldsoft active:scale-95 transition-[transform,border-color]"
      >
        {open ? <X size={18} /> : <HelpCircle size={18} className="text-goldsoft" />}
        <span className="text-sm font-semibold">Need Help?</span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ duration: 0.18 }}
            data-testid="help-panel"
            className="fixed bottom-20 left-5 z-[60] w-[280px] bg-white rounded-2xl shadow-2xl border border-[#E5DFD3] p-4"
          >
            <p className="font-display text-lg font-semibold text-choco mb-1">We're here to help</p>
            <p className="text-xs text-muted-foreground mb-3">Reach Nel Bake House directly.</p>
            <div className="space-y-2">
              {phone && (
                <a href={`tel:${phone}`} data-testid="help-call" className="flex items-center gap-3 rounded-xl bg-cream px-3 py-2.5 hover:bg-mutedcream transition-colors">
                  <Phone size={18} className="text-goldsoft" /><span className="text-sm font-medium text-choco">Call {phone}</span>
                </a>
              )}
              {phone && (
                <a href={waLink(phone)} target="_blank" rel="noreferrer" data-testid="help-whatsapp" className="flex items-center gap-3 rounded-xl bg-cream px-3 py-2.5 hover:bg-mutedcream transition-colors">
                  <MessageCircle size={18} className="text-green-600" /><span className="text-sm font-medium text-choco">Chat on WhatsApp</span>
                </a>
              )}
              {email && (
                <a href={`mailto:${email}`} data-testid="help-email" className="flex items-center gap-3 rounded-xl bg-cream px-3 py-2.5 hover:bg-mutedcream transition-colors">
                  <Mail size={18} className="text-goldsoft" /><span className="text-sm font-medium text-choco break-all">{email}</span>
                </a>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
